//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from '../components/footer.vue'
import {
  SaunaPreshiftQuery
} from '../../static/js/api.js'




function loadtotal(that) {


    SaunaPreshiftQuery({}, function (res) {
        console.log(res)
        if (res.data.IsSuccess) {

            that.data = JSON.parse(res.data.Result)
            that.loading=false

            console.log(that.data)
        } else {

            that.$vux.toast.text('数据获取失败，请重试', 'middle')

        }


    })

}



export default {
  name: 'app',
  components: {
    'pc-footer': Footer,
  },
  data() {
    return {
      loading:true,
      data: {
        ShiftCode: {},
        ShiftDate: {},
        PayModeDetails: {},
          PayModeSummary: {},
        GuestPerConsume: {},
        CardConsumes: {},
        CataConsumes: {},
        BarConsumes: {},
        IncomeMoney:{},
        UnIncomeMoney:{},
        CataConsumesSummary:{},
        CardSummary:{}
      },

      showContent001: false,
      showContent002: false,
      showContent003: false,
      showContent004: false,
      showContent005: false,
      showContent006: false,


        selected:1,

        nav:[
            {
                id:1,
                name:"收款统计"

            },
            {
                id:2,
                name:"销售明细"

            },
            {
                id:3,
                name:"卡种消费"

            },{
                id:4,
                name:"人均消费"

            }
            ,{
                id:5,
                name:"吧台收入"

            }

        ],
    }
  },
  created() {
    var that = this
    loadtotal(that)

  },

  methods: {
      refresh(){
          this.loading=true
          var that=this
          loadtotal(that)


      },
      change(index){
          console.log(index)
          this.selected= parseInt(index+1)

      },
  }
}



// WEBPACK FOOTER //
// ./src/pages/jiaoban.vue